import {
  select,
  fork,
  put,
  all,
  call,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'

import {
  FETCH_USER_PROFILE_SUCCESS
} from 'containers/App/App/constants'

import {
  CHANGE_GLOBAL_ROLE,
} from './constants'

import {
  changeGlobalRole,
  changeGlobalRoleStart,
  changeGlobalRoleSuccess,
  updateGlobalRole,
  updateProjectRole,
  updateDataManagerRole,
  updateClientRole
} from './actions'

function* handleChangeGlobalRole({ attributes }) {
  const { projectCreate, dataManager, role, isClient } = attributes
  yield put(changeGlobalRoleStart())
  yield put(updateGlobalRole(role))
  yield put(updateProjectRole(projectCreate))
  yield put(updateDataManagerRole(dataManager))
  // this will overide the site roles
  yield put(updateClientRole(isClient))
  yield put(changeGlobalRoleSuccess())
}

function* handleFetchUserProfileSuccess(action) {
  const { attributes } = action
  yield put(changeGlobalRole(attributes))
}

function* watchFetchUserProfileSuccess() {
  yield takeLatest(FETCH_USER_PROFILE_SUCCESS, handleFetchUserProfileSuccess)
}

function* watchChangeGlobalRole() {
  yield takeLatest(CHANGE_GLOBAL_ROLE, handleChangeGlobalRole)
}

function* loadSagas() {
  yield all([
    fork(watchFetchUserProfileSuccess),
    fork(watchChangeGlobalRole),
  ])
}

export default loadSagas
